import type { Publication } from '../types'

/**
 * What to say when nothing was published. When every platform refused for the
 * same reason (the publish-time compliance check, say), that reason is the
 * message: it says what to change. Otherwise `fallback`.
 */
export const publishFailureText = (publications: Publication[], fallback: string): string => {
  const reasons = Array.from(new Set(publications.map((p) => p.error_message).filter(Boolean)))
  return reasons.length === 1 ? `Not published: ${reasons[0]}` : fallback
}
